import { END_POINT } from './constant'

type SubmitFormRequest = {
  data: Record<string, unknown>
  formId: number
}

type SubmitFormResponse = {
  error: string
  insert_id: number
  result: {
    action: string
    message: string
  }
}

export async function submitForm(request: SubmitFormRequest) {
  const response = await fetch(END_POINT, {
    body: JSON.stringify(request),
    headers: {
      'Content-Type': 'application/json',
    },
    method: 'POST',
  })

  return response.json() as Promise<SubmitFormResponse>
}
